import React, { useState, useEffect } from 'react';
import '../styles/Booking.css';
import { getDatabase, ref, set, get } from 'firebase/database';
import { app } from '../firbase';
import { useNavigate } from 'react-router-dom';
import sendEmail from './emailjs_script';


const Booking = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    table: '',
    date: '',
    startTime: '',
    endTime: '',
    mode: '',  
  });

  const [allBookings, setAllBookings] = useState([]);
  const navigate = useNavigate();
  const db = getDatabase(app);
  const [disabledStartTimes, setDisabledStartTimes] = useState([]);
  const [disabledEndTimes, setDisabledEndTimes] = useState([]);

  const timeSlots = [
    '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM', '1:00 PM', '1:30 PM', '2:00 PM',
    '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM', '4:30 PM', '5:00 PM', '5:30 PM',
    '6:00 PM', '6:30 PM', '7:00 PM', '7:30 PM', '8:00 PM', '8:30 PM', '9:00 PM',
    '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM', '12:00 AM',
    '12:30 AM', '1:00 AM', '1:30 AM', '2:00 AM', '2:30 AM', '3:00 AM'
  ];

  const tables = [
    { value: 'S1', label: 'S1 => SteelCushion PRO Rs.300/hr' },
    { value: 'S2', label: 'S2 => MillenniumMs PRO Rs.250/hr' },
    { value: 'S3', label: 'S3 => SharmaS2 PRO Rs.240/hr' },
    { value: 'M1', label: 'M1 => 8-Ball/snooker 9/5ft Rs.200/hr' },
    { value: 'M2', label: 'M2 => 8-ball/snooker 10/5ft Rs.220/hr' },
    // { value: 'M3', label: 'M3 => only 8-ball 6/4ft Rs.180/hr' },
  ];
  

  useEffect(() => {
    if (formData.date && formData.table) {
      const bookingsRef = ref(db, 'bookings/');
      get(bookingsRef).then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const filtered = Object.values(data).filter(
            (b) => b.date === formData.date && b.table === formData.table
          );
          setAllBookings(filtered);
          setFormData((prev) => ({ ...prev, startTime: '', endTime: '' }));


           // disable all booked time slots
           let startDisabled = new Set();
           let endDisabled = new Set();
         filtered.forEach(({ startTime, endTime }) => {
           const start = timeToValue(startTime);
           const end = timeToValue(endTime);
           timeSlots.forEach((slot) => {
             const val = timeToValue(slot);
             if (val > start && val < end) {
                 startDisabled.add(slot); // for startTime
                 endDisabled.add(slot);   // for endTime
               }
               if (val === end) {
                 endDisabled.add(slot); // prevent choosing exact end time
               }
               if (val === start) {
                 startDisabled.add(slot); // prevent choosing exact end time
               }
           });
         });

          setDisabledStartTimes(Array.from(startDisabled));
          setDisabledEndTimes(Array.from(endDisabled));
        } else {
          setAllBookings([]);
          setDisabledStartTimes([]);
          setDisabledEndTimes([]);
        }
      });
    }// eslint-disable-next-line
  }, [formData.date, formData.table]);

  const timeToValue = (time) => {
    const [hour, minPart] = time.split(':');
    const minutes = parseInt(minPart.slice(0, 2), 10);
    const isPM = time.toLowerCase().includes('pm');
    let hr = parseInt(hour, 10);
    if (isPM && hr !== 12) hr += 12;
    if (!isPM && hr === 12) hr = 0;
    let totalMinutes = hr * 60 + minutes;
    if (totalMinutes <= 180) totalMinutes += 1440;
    return totalMinutes;
  };


  const getFilteredTimeSlots = () => {
    if (!formData.date) return timeSlots;
  
    const selectedDate = new Date(formData.date);
    const now = new Date();
  
    // Clone and normalize both dates to midnight
    const selectedDay = new Date(selectedDate);
    const today = new Date(now);
  
    selectedDay.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
  
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();
  
    const currentTimeValue = timeToValue(
      `${currentHour % 12 || 12}:${currentMinutes.toString().padStart(2, '0')} ${currentHour >= 12 ? 'PM' : 'AM'}`
    );
  
    const isSameDay = selectedDay.getTime() === today.getTime();
    const isPreviousDay = selectedDay.getTime() === today.getTime() - 86400000; // 1 day in ms
    const isPastDay = selectedDay < today && !isPreviousDay;
  
    // Fully past day (e.g., trying to book 17th on 19th)
    if (isPastDay) return [];
  
    // Booking for previous day (early morning hours, 12am–3am)
    if (isPreviousDay && currentHour < 3) {
      return timeSlots.filter(slot => timeToValue(slot) > currentTimeValue);
    }
  
    // // Booking for today (after 3am), show only future slots
    if (isSameDay) {
      return timeSlots.filter(slot => timeToValue(slot) > currentTimeValue);
    }
    
  
    // Booking for future day — show full slot list
    return timeSlots;
  };
  
  
  

  const hasOverlap = () => {
    const start = timeToValue(formData.startTime);
    const end = timeToValue(formData.endTime);
    return allBookings.some((b) => {
      const bookedStart = timeToValue(b.startTime);
      const bookedEnd = timeToValue(b.endTime);
      return start < bookedEnd && end > bookedStart;
    });
  };

  const isPastDate = (date) => {
    const selected = new Date(date);
    const now = new Date();
  
    const isEarlyMorning = now.getHours() < 3;
    const effectiveToday = new Date();
    effectiveToday.setDate(effectiveToday.getDate() - (isEarlyMorning ? 1 : 0));
    effectiveToday.setHours(0, 0, 0, 0);
  
    selected.setHours(0, 0, 0, 0);
    return selected < effectiveToday;
  };
  

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const validateName = (name) => /^[a-zA-Z\s.,!?'-]*$/.test(name);
  const validatePhone = (phone) => /^[0-9]{10}$/.test(phone);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, phone, table, date, startTime, endTime, mode } = formData;

    if (!name || !phone || !table || !date || !startTime || !endTime || !mode) {
      alert('All fields are required!');
      return;
    }
    if (isPastDate(date)) {
      alert('Cannot book for past dates.');
      return;
    }
    if (timeToValue(startTime) >= timeToValue(endTime)) {
      alert('Start time must be earlier than end time.');
      return;
    }
    if (hasOverlap()) {
      alert('This slot is already booked for the selected table!');
      return;
    }
    if (!validateName(name)) {
      alert('Name can only contain letters, punctuation, and spaces.');
      return;
    }
    if (!validatePhone(phone)) {
      alert('Phone number must be 10 digits.');
      return;
    }

    if (timeToValue(endTime) - timeToValue(startTime) < 60) {
      alert('Minimum booking duration is 1 hour.');
      return;
    }

 
    

    const bookingId = `${phone}`;
    const bookingRef = ref(db, 'bookings/' + bookingId);
    set(bookingRef, formData)
      .then(() => {
        sendEmail(formData, 'NEW BOOKING'); // 📧 send confirmation email
        navigate('/confirmation', { state: formData });
      })
      .catch((err) => alert('Booking failed: ' + err.message));

      
  };

  return (
    <div className="booking-page">
      <h2 className="booking-title">BOOK YOUR TABLE</h2>
      <form className="booking-form" onSubmit={handleSubmit}>
        {['name', 'phone', 'date'].map((field) => (
          <div className="booking-field" key={field}>
            <label htmlFor={field} className="booking-label">
              {field.charAt(0).toUpperCase() + field.slice(1)}
            </label>
            <input
              className="booking-input"
              type={field === 'date' ? 'date' : 'text'}
              id={field}
              value={formData[field]}
              onChange={handleChange}
              required
            />
          </div>
        ))}

<label htmlFor="mode" className="booking-label">Mode of Booking</label>
<select id="mode" className="booking-select" value={formData.mode} onChange={handleChange} required>
  <option value="">Select Mode</option>
  <option value="online">Online</option>
  <option value="walk-in">Walk-in</option>
</select>

        <label htmlFor="table" className="booking-label">Table</label>
        <select id="table" className="booking-select" value={formData.table} onChange={handleChange} required>
          <option value="">Select Table</option>
          {tables.map((t) => (
    <option key={t.value} value={t.value}>
      {t.label}
    </option>
  ))}

        </select>

        <label htmlFor="startTime" className="booking-label">Start Time</label>
        <select id="startTime" className="booking-select" value={formData.startTime} onChange={handleChange}>
          <option value="">Select Start Time</option>
          {getFilteredTimeSlots().map((slot) => (
            <option key={slot} value={slot} disabled={disabledStartTimes.includes(slot)}>
              {slot}
            </option>
          ))}
        </select>

        <label htmlFor="endTime" className="booking-label">End Time</label>
        <select id="endTime" className="booking-select" value={formData.endTime} onChange={handleChange}>
          <option value="">Select End Time</option>
          {getFilteredTimeSlots().map((slot) => (
            <option key={slot} value={slot} disabled={disabledEndTimes.includes(slot)}>
              {slot}
            </option>
          ))}
        </select>

        <button type="submit" className="booking-button">SUBMIT</button>
      </form>
    </div>
  );
};

export default Booking;
